export const defaultTransitionDuration: any = '.3s';
